import React from "react";

const sizes = {
  h4_assistant16px_r: "text-[16px] font-normal lg:text-[13px]",
  h4_assistant_18px_r: "text-[18px] font-normal lg:text-[15px]",
  textmd: "text-[14px] font-normal",
  textlg: "text-[15px] font-normal",
  textxl: "text-[16px] font-normal lg:text-[13px]",
  text4xl: "text-[22px] font-normal lg:text-[18px]",
  text5xl: "text-[24px] font-normal lg:text-[20px] md:text-[22px]",
  text6xl: "text-[25px] font-normal lg:text-[21px] md:text-[23px] sm:text-[21px]",
  text7xl: "text-[28px] font-normal lg:text-[23px] md:text-[26px] sm:text-[24px]",
  text9xl: "text-[40px] font-normal lg:text-[34px] md:text-[38px] sm:text-[36px]",
  text10xl: "text-[41px] font-normal lg:text-[34px] md:text-[37px] sm:text-[31px]",
  text11xl: "text-[44px] font-normal lg:text-[37px] md:text-[40px] sm:text-[34px]",
  text12xl: "text-[45px] font-light lg:text-[38px] md:text-[41px] sm:text-[35px]",
};

const Text = ({ children, className = "", as, size = "textmd", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`text-black-900 font-heebo ${className} ${sizes[size]} `} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
